// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3WpbX","alertIcon":"ConfirmModal_alertIcon__1Wyql"};